import React from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from "prop-types";
import Button from '../../../Common/Button';
import intl from "react-intl-universal";
import styles from './index.module.scss';
import * as actions from "../../../../store/action/exchange";

class Module extends React.Component {
    constructor(props) {
        super(props);
    }

    static defaultProps = {
        text: '',
        category: 1,
    };

    static propTypes = {
        text: PropTypes.string, // 空状态文案
        category: PropTypes.number, // 兑换类型 1-头像框  2-弹幕框  3-视频框  4-实物奖励
    };

    componentDidMount() {
    }

    /**
     * 去兑换
     * @param category {Number} 品类
     */
    goToExchange = (category) => {
        let categoryTabType;
        switch(category) {
            case 1:
                // 头像框
                categoryTabType = 'avatar';
                break;
            case 2:
                // 弹幕框
                categoryTabType = 'subtitles';
                break;
            case 3:
                // 视频框
                categoryTabType = 'video';
                break;
            case 4:
                // 实物
                categoryTabType = 'gift';
                break;
        }
        this.props.changeTabType(categoryTabType);
    };


    render() {
        const {
            text,
            category
        } = this.props;

        return (
            <div className={styles.emptyWrap}>
                <div className={styles.text}>{text}</div>
                <div className={styles.btnBox}>
                    <Button onClick={() => this.goToExchange(category)}>{intl.get('TO_EXCHANGE')}</Button>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    ...state.exchange
});

const mapDispatchToProps = dispatch => bindActionCreators(actions, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(Module));